import { useCallback } from 'react';
import { useQontoWebsocket, useQontoWebsocketConnection } from '@repo/shared-kit/websocket';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';

interface FourthlineWebsocketProps {
  websocketToken: string;
  userId: string;
  onError: (payload: unknown) => void;
  onProcessFinished: (payload: unknown) => void;
}

export function FourthlineWebsocket({
  websocketToken,
  userId,
  onError,
  onProcessFinished,
}: FourthlineWebsocketProps) {
  const env = getEnvironmentVariables();
  const { backendUrlsTable } = getUrlsTable(env);

  useQontoWebsocketConnection({
    websocketBaseURL: backendUrlsTable.websocketBaseURL,
    token: websocketToken,
    userId,
  });

  const memoizedOnError = useCallback(
    (payload: unknown) => {
      onError(payload);
    },
    [onError]
  );

  const memoizedOnProcessFinished = useCallback(
    (payload: unknown) => {
      onProcessFinished(payload);
    },
    [onProcessFinished]
  );

  useQontoWebsocket('error', memoizedOnError);
  useQontoWebsocket('process_finished', memoizedOnProcessFinished);

  return null;
}
